import { render, staticRenderFns } from "./ProfileIdentVolunteerFormStandard.vue?vue&type=template&id=27298772"
import script from "./ProfileIdentVolunteerFormStandard.vue?vue&type=script&lang=ts"
export * from "./ProfileIdentVolunteerFormStandard.vue?vue&type=script&lang=ts"
import style0 from "./ProfileIdentVolunteerFormStandard.vue?vue&type=style&index=0&id=27298772&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports